import * as Linking from 'expo-linking';

export default {
  prefixes: [Linking.createURL('/'), 'https://app-dev.plentifulapp.com', 'https://app.plentifulapp.com'],
  config: {
    screens: {
      Language: 'language',
      PhoneOrEmail: 'welcome',
      VerificationEmailSent: 'verification_email_sent',
      CreatePassword: 'create_password',
      EnterPassword: 'password',
      EnterPhone: 'phone',
      EnterEmail: 'email',
      LoginByMagicLink: 'login_by_magic_link',
      TermsPrivacy: 'terms',
      EmailVerified: {
        path: 'verify_email',
        parse: {
          verification_code: (code) => code,
        },
      },
      EmailUnsubscribed: 'unsubscribe',
      OtpCode: 'otp',
      UserDetails: 'user_details',
      FamilyDetails: 'family_details',
      AdditionalDetails: 'additional_details',
      AccountCreated: 'account_created',
      ResetPassword: 'reset_password',
      ResetPasswordSent: 'reset_password_sent',
      Pantry: 'pantry/:id/:shortname?',
      Logout: 'logout',
      a: {
        path: 'a',
        screens: {
          pantries: 'pantries',
          visits: 'visits',
          updates: 'updates',
          profile: {
            path: 'profile',
            screens: {
              landing: 'landing',
              info: 'info',
              settings: 'settings',
              support: 'support',
            },
          },
        },
      },
    },
  },
};
